import { post } from '../../common/apiMethods';

export const addEmailContact = body => {
  return post('/api/email/contact', body);
};
